import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/user/auth-slice';
import chatSettingsReducer from './features/chatSettings/chat-settings-slice';
import { baseApi } from './api/base-api';
import { authErrorMiddleware } from './api/middleware';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    chatSettings: chatSettingsReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware, authErrorMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
